// TICKET-01329: accounting/reporting integration state must never follow a
// sale into a copy (credit note, duplicate). If it does, the new sale renders
// as already "Overført" to accounting and the send buttons never appear, with
// no way for the clinic to clear it. Every integration keeps its sale-level
// state under one of these prefixes (see backend saleSchema.js).
const INTEGRATION_FIELD_PREFIXES = ['fiken', 'tripletex', 'powerOffice', 'duett', 'convene', 'animalia', 'nets'];

/**
 * Remove all accounting/reporting integration state from a sale object, in
 * place. Call it on a local copy of a sale (e.g. the `{ ...newSale }` spread
 * in the credit-note flows), never on a store observable directly.
 * Returns the same object for convenience.
 */
export function stripAccountingIntegrationState(sale) {
    if (!sale || typeof sale !== 'object') {
        return sale;
    }
    Object.keys(sale).forEach(key => {
        if (INTEGRATION_FIELD_PREFIXES.some(prefix => key.startsWith(prefix))) {
            delete sale[key];
        }
    });
    return sale;
}

// TICKET-01691: the samlefaktura links must not follow a sale into a copy either.
// A credit note built from `{ ...newSale }` carried the parent's `subInvoices`, and
// the backend sub-invoice guard (TICKET-01018) refused the insert with 409 because
// those underbilag were already status 1005. The original had already been marked
// "Salg kreditert", so the clinic was left with no credit note behind it.
const COLLECTIVE_INVOICE_LINK_FIELDS = ['subInvoices', 'parentSaleId', 'parentSaleNumber'];

/**
 * Remove the samlefaktura links (sub-invoice list and parent reference) from a
 * sale object, in place. Same contract as stripAccountingIntegrationState: call
 * it on a local copy, never on a store observable. Returns the same object.
 */
export function stripCollectiveInvoiceLinks(sale) {
    if (!sale || typeof sale !== 'object') {
        return sale;
    }
    COLLECTIVE_INVOICE_LINK_FIELDS.forEach(field => {
        delete sale[field];
    });
    return sale;
}

export default { stripAccountingIntegrationState, stripCollectiveInvoiceLinks };
